import { render } from "./HalamanGaleri.vue?vue&type=template&id=7165b646&scoped=true"
import script from "./HalamanGaleri.vue?vue&type=script&lang=js"
export * from "./HalamanGaleri.vue?vue&type=script&lang=js"

import "./HalamanGaleri.vue?vue&type=style&index=0&id=7165b646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7165b646"]])

export default __exports__